<template>
<el-container class="el-container">
  <el-header class="el-header">
    <el-menu :default-active="$route.path" class="el-menu-demo"
             mode="horizontal" router >
      <el-menu-item>
        <router-link to="/log" tag="el-menu-item" style="background: #ffffff" replace>日志记录</router-link>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">资源维护</template>
        <router-link to="/project" tag="el-menu-item">项目管理</router-link>
        <router-link to="/contactPerson" tag="el-menu-item">对接人维护</router-link>
        <router-link to="/loveLog" tag="el-menu-item">恋爱日志♥</router-link>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">小工具🔐</template>
        <router-link to="/summaryBurner" tag="el-menu-item">📄&nbsp;摘要生成</router-link>
        <router-link to="/fileAnswer" tag="el-menu-item">📂&nbsp;文档问答</router-link>
      </el-submenu>
      <router-link to="/home" tag="el-menu-item">主菜单</router-link>
    </el-menu>
    <div>
      <!-- 使用 el-dropdown 组件，将触发方式设置为 click -->
      <el-dropdown @command="handleCommand"  style="margin-top: 5px"  trigger="click">
        <!-- 使用 el-avatar 作为下拉触发元素 -->
        <el-avatar
          style="cursor: pointer;"
          src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png">
        </el-avatar>
        <!-- 在 el-dropdown 中添加小箭头图标 -->
        <div style="position: absolute; bottom: -10px; right: 10px;">
          <i class="el-icon-arrow-down"></i>
        </div>
        <!-- 下拉菜单内容 -->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="bindMail">绑定邮箱</el-dropdown-item>
          <el-dropdown-item command="editPwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登陆</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 绑定邮箱 -->
    <el-dialog class="custom-dialog"
               title="绑定邮箱"
               :visible.sync="dialogStatus.bindMailStatus"
               width="50%"
               destroy-on-close>
      <!-- 表单内容 -->
      <el-form ref="userMail" status-icon :model="userMail" label-width="100px">
          <!-- 项目名称输入 -->
          <el-form-item label="邮箱账号:">
            <el-input class="el-select-addlog" v-model="userMail"
                      clearable filterable placeholder="请输入邮箱账号">
            </el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus.bindMailStatus = false">取 消</el-button>
        <el-button type="primary" @click="bindMail">提交</el-button>
      </span>
    </el-dialog>

    <!--修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogStatus.editPwdStatus"
      width="20%"
      @close="editPwdParams={oldPassword: '',newPassword: '',confirmPassword: ''}">
      <el-form ref="editPwdParams" status-icon :model="editPwdParams" :rules="editPwdRules" label-width="80px">
        <el-form-item label="原始密码" >
          <el-input type="password" v-model="editPwdParams.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="editPwdParams.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="editPwdParams.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogStatus.editPwdStatus = false">取 消</el-button>
          <el-button type="primary" @click="editPwd">提交</el-button>
        </span>
    </el-dialog>
  </el-header>
  <el-main class="el-main">
    <router-view/>
  </el-main>
</el-container>
</template>
<script>
import RSA from '../utils/RSAencrypt'

export default {
  data () {
    return {
      dialogStatus: {
        bindMailStatus: false,
        editPwdStatus: false,
        logoutStatus: false
      },
      userMail: '',
      editPwdParams: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      editPwdRules: {
        newPassword: [
          { validator: this.validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: this.validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSelectMenu (path) {
      this.$router.push({ path: path })
    },
    handleCommand (command) {
      if (command === 'bindMail') { // 绑定邮箱
        this.dialogStatus.bindMailStatus = true
        // 获取邮箱
        this.$axios.get('/api/auth/getMail').then((response) => {
          if (response.data.code === 200) {
            // 处理请求数据
            this.userMail = response.data.data
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (command === 'editPwd') {
        this.dialogStatus.editPwdStatus = true
      } else if (command === 'logout') {
        this.logout()
      }
    },
    checkToken () {
      // 获取 localStorage 中的 tokenName 和 tokenValue
      const tokenName = localStorage.getItem('tokenName')
      const tokenValue = localStorage.getItem('tokenValue')

      // 检查 tokenName 和 tokenValue 是否都存在且不为 null
      if (tokenName === null || tokenValue === null) {
        // 如果任一不存在或为 null，则跳转到登录页
        this.$router.push({ path: '/' })
      } else {
        // 如果两者都存在，可以继续执行其他逻辑
        // 例如，发送请求到服务器验证 token 是否有效
      }
    },
    bindMail () {
      this.$axios.get('/api/auth/bindingeMail', {
        params: {
          mail: this.userMail
        }
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.$message({
              message: response.data.message,
              type: 'success'
            })
          } else if (response.data.code === 500) {
            this.$message({
              message: response.data.message,
              type: 'error'
            })
          }
        }).catch((error) => {
          this.$message({
            message: '绑定邮箱失败',
            type: 'error'
          })
        })
      this.dialogStatus.bindMailStatus = false
    },
    validatePass2  (rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.editPwdParams.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    validatePass (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.editPwdParams.newPassword !== '') {
          // this.$refs.ruleForm.validateField('newPassword');
        }
        callback()
      }
    },
    editPwd () {
      const params = {
        oldPassword: RSA.RSAencrypt(this.editPwdParams.oldPassword),
        newPassword: RSA.RSAencrypt(this.editPwdParams.newPassword)
      }
      this.$axios.post('/api/auth/updatePassword', params)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message({
              message: response.data.message,
              type: 'success'
            })
          } else if (response.data.code === 500) {
            this.$message({
              message: response.data.message,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error)
          this.$message({
            message: '修改密码失败',
            type: 'error'
          })
        }).finally(()=>{
          this.dialogStatus.editPwdStatus = false
      })
    },
    logout () {
      this.$confirm('退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.get('/api/auth/logout')
          .then((response) => {
            if (response.data.code === 200) {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              // 非200状态码的处理（如果需要）
              this.$message({
                message: '退出登录操作失败，请稍后再试',
                type: 'error'
              })
            }
          }).catch((error) => {
            this.$message({
              message: '退出登录请求失败，请检查网络连接或稍后再试',
              type: 'error'
            })
          })
        // 清除本地存储中的 token 和 tokenHead
        localStorage.removeItem('tokenName')
        localStorage.removeItem('tokenValue')
        this.$router.push({ path: '/' })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    }
  },
  created () {
    this.checkToken()
  }
}
</script>

<style  scoped>
/* 定义全局样式 */
.el-header {
  color: #333;
  text-align: center;
  height: 15vh;
  display: flex; /*使用Flexbox 布局*/
  justify-content: center; /*水平剧中*/
}
.el-menu-demo {
  width: 100%; /* 确保菜单宽度占满其父容器 */
  display: flex; /* 使用Flexbox布局 */
  justify-content: space-around; /* 平铺菜单项，每个项之间有相等的空间 */
}
.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 200px;
}
.el-container {
  height: 100vh;
  width: 100vw; /* 这里建议改为 100vw */
  margin-bottom: 0; /* 移除底部外部框*/
  display: flex;  /*使用Flexbox 布局*/
  flex-direction: column;  /*子元素按列排序*/
}
.el-main {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  height: 85vh;
  display: flex;
  align-items: center; /* 更正为 align-items */
  justify-content: center;
}

/* 定义特定 .el-container 中的 .el-aside 样式 */
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeV2.vue